/** Body para POST /quiz al duplicar: copia pregunta, opciones y puntuación (nuevo _id en servidor). */
function buildQuizDuplicatePayload(sourceQuiz) {
	if (!sourceQuiz) {
		return {
			fullName: "Pregunta (copia)",
			questions: [{ type: "multipleChoice", text: "Pregunta", options: [{ text: "Opción 1", imageUrl: "", correct: true }], explanation: "" }],
			pointsCorrect: 10,
			pointsIncorrect: -5,
			allowMultipleAttempts: false,
			attemptMode: "single",
			maxAttempts: 3,
		};
	}
	const q0 = sourceQuiz.questions?.[0];
	const questions = q0
		? [JSON.parse(JSON.stringify(q0))]
		: [{ type: "multipleChoice", text: "Pregunta", options: [{ text: "Opción 1", imageUrl: "", correct: true }], explanation: "" }];
	const name = String(sourceQuiz.fullName || "Pregunta").trim() || "Pregunta";
	return {
		fullName: `${name.slice(0, 72)} (copia)`,
		questions,
		pointsCorrect: sourceQuiz.pointsCorrect != null ? Number(sourceQuiz.pointsCorrect) : 10,
		pointsIncorrect: sourceQuiz.pointsIncorrect != null ? Number(sourceQuiz.pointsIncorrect) : -5,
		allowMultipleAttempts:
			sourceQuiz.attemptMode != null ? sourceQuiz.attemptMode !== "single" : !!sourceQuiz.allowMultipleAttempts,
		attemptMode: sourceQuiz.attemptMode || (sourceQuiz.allowMultipleAttempts ? "unlimited" : "single"),
		maxAttempts: Math.max(1, Number(sourceQuiz.maxAttempts) || 3),
	};
}

export { buildQuizDuplicatePayload };
